<template>
    <div class="main-login" :style="cssVars">
        <v-row class="justify-center align-center no-gutters">
            <v-col cols="12" lg="4" md="5" sm="6" xl="3">
                <div class="form-login">
                    <v-img :src="imgSrc" width="166"/>
                    <h2 class="primary--text">{{ projectName }}</h2>

                    <v-form ref="login" v-model="valid"
                            @keypress.native.enter="login">
                        <v-text-field
                            v-model="email"
                            :label="$t('login.identifier')"
                            :rules="login_rules"
                            dense
                            outlined
                            persistent-placeholder
                            placeholder=" "
                            type="text"
                        ></v-text-field>

                        <v-text-field
                            v-model="password"
                            :label="$t('login.password')"
                            :rules="password_rules"
                            dense
                            outlined
                            persistent-placeholder
                            placeholder=" "
                            type="password"
                        ></v-text-field>

                        <a
                            class="forgot-password"
                            @click="$router.push(
                                {
                                 name: 'forgot_password',
                                 query:{
                                     email,
                                 }
                                })"
                        >
                            {{ $t("login.forgot_password") }}
                        </a>

                        <v-btn
                            :loading="loading"
                            block
                            color="primary"
                            elevation="0"
                            @click="login"
                            @keypress.native.enter="login"
                        >
                            {{ $t("login.connexion") }}
                        </v-btn>
                    </v-form>
                </div>
            </v-col>
        </v-row>
        <v-snackbar
            v-model="display"
            :color="notify.color"
            :timeout="timeout"
            right
            top
        >
            <ul>
                <li v-for="text in notify.data" :key="text">
                    <strong>{{ text }}</strong>
                </li>
            </ul>
            <template #action="{ attrs }">
                <v-progress-circular
                    :rotate="-90"
                    :size="100"
                    :value="value"
                    :width="10"
                    color="white"
                    style="max-height: 30px;"
                >
                    <v-btn
                        icon
                        text
                        v-bind="attrs"
                        @click="display = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-progress-circular>

            </template>
        </v-snackbar>
    </div>
</template>

<script>

import {showSnackbar} from "../functions";
import Config from '../config.singleton'

export default {
    name: "Login",
    data() {
        return {
            valid: false,
            email: null,
            password: null,
            login_rules: [(v) => !!v || this.$t("login.required_login")],
            password_rules: [(v) => !!v || this.$t("login.required_password")],
            loading: false,
            display: false,
            timeout: 5750,
            notify: {
                data: [],
                color: "warning"
            },
            value: 100,
        };
    },
    computed: {
        projectName() {
            return Config.project_name ?? this.$t("global.app_name")
        },
        imgSrc() {
            return Config.project_logo ?? 'images/logo.svg'
        },
        cssVars() {
            return {
                '--bg-img': `url(${Config.project_background ?? '/images/camion.jpg'})`
            }
        }
    },

    mounted() {
        this.$root.clearStorage();
    },
    methods: {
        login() {
            this.loading = true
            if (this.$refs.login.validate()) {
                this.$auth.login({
                    data: {
                        provider: "users",
                        credentials: {
                            identifier: this.email,
                            password: this.password
                        }
                    }
                })
                    .catch(err => {
                        if (err.response.status === 404) {
                            showSnackbar("warning", this.$t('errors.invalid_credentials'))
                        }
                    })
                    .finally(() => this.loading = false)
            } else {
                this.loading = false
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.main-login {
    background-image: var(--bg-img);
}
</style>
